export default __webpack_public_path__ + "static/solidified-remains-thumb-d94c3ccb5b60f4ace98f547ec793ae3b.png";